var juriu = [
	{
		nume:'Jean-Marc Laforge',
		job:'Chief Creative Director',
		company:'Geometry Paris'
	},
	{
		nume:'Dave Grimaldi',
		job:'Executive Vice President',
		company:'IAB US'
	},
	{
		nume:'Townsend Feehan',
		job:'CEO',
		company:'IAB EU'
	},
	{
		nume:'Sanja Dekic',
		job:'Executive Director',
		company:'IAB SRB'
	},
	{
		nume:'Dan Sendroiu',
		job:'Head of Strategy',
		company:'Friends TBWA'
	},
	{
		nume:'Andrei Balan',
		job:'Head of Strategy',
		company:'MRM'
	},
	{
		nume:'Stefan Chiritescu',
		job:'Head of Strategy',
		company:'Kubis'
	},
	{
		nume:'Cristina Ungureanu',
		job:'Head of Strategy',
		company:'Geometry Global Bucharest'
	},
	{
		nume:'Diana Caracota',
		job:'Head of Strategy',
		company:'Cohn&Jansen JWT'
	},
	{
		nume:'Felicia Stoica',
		job:'Group Creative Director',
		company:'Jazz'
	},
	{
		nume:'Diana Ceausu',
		job:'VP, Global Strategy Director',
		company:'Commonwealth//McCann US'
	},
	{
		nume:'Claudiu Dobrita',
		job:'Creative Director',
		company:'FCB Bucharest'
	},
	{
		nume:'Ruxandra Papuc',
		job:'Group Creative Director',
		company:'McCann Worldgroup Romania'
	},
	{
		nume:'Cosmin Baba',
		job:'Creative Director',
		company:'V8 Interactive'
	},
	{
		nume:'Anamaria Nicoda',
		job:'Creative Director',
		company:'Hogarth Worldwide Ltd'
	},
	{
		nume:'Alex Cotet',
		job:'Scenarist & Regizor',
		company:'Sector 7'
	},
	{
		nume:'Andreea Irinca',
		job:'Media Strategist',
		company:'Mindshare'
	},
	{
		nume:'Cristian Manafu',
		job:'Social Media Consultant',
		company:'Evensys'
	},
	{
		nume:'Victor Rotariu',
		job:'Head of Insights, Content & Strategy',
		company:'Wavemaker'
	},
	{
		nume:'Noemi Varga',
		job:'Marketing Director',
		company:'Tchibo'
	},
	{
		nume:'Cosmin Nastasa',
		job:'Founder',
		company:'Data Revolt Agency'
	},
	{
		nume:'Cristina Radu',
		job:'Marketing Director',
		company:'Stalinskaya'
	},
	{
		nume:'Gabriel Patru',
		job:'President',
		company:'IAB Romania'
	},
	{
		nume:'Oana Lupoaie',
		job:'AdNetwork Director',
		company:'Think Digital'
	},
	{
		nume:'Oana Petroff',
		job:'CEO',
		company:'Mediacom Romania'
	},
	{
		nume:'Ana Visian',
		job:'Advertising Sales Manager',
		company:'OLX Group România'
	},
	{
		nume:'Ionut Oprea',
		job:'General Manager',
		company:'Standout & Facebrands'
	},
	{
		nume:'Mihai Tanase',
		job:'Head of Digital & CRM',
		company:'Renault'
	},
	{
		nume:'Andrei Dragu',
		job:'Business Development Director',
		company:'V8 Interactive'
	},
	{
		nume:'Cristi Petriceanu',
		job:'Country Manager',
		company:'Madhouse Advertising'
	},
	{
		nume:'Doina Radicoff',
		job:'Head of Sales & Client Service',
		company:'Gemius Romania & Moldova'
	},
	{
		nume:'Maria Predoiu',
		job:'President',
		company:'IAA'
	},
	{
		nume:'Alina Damaschin',
		job:'Creative Leader & Managing Partner',
		company:'Rogalski Damaschin PR'
	},
	{
		nume:'Stefan Iordache',
		job:'President',
		company:'UAPR'
	},
	{
		nume:'Razvan Capanescu',
		job:'Chief Creative Officer',
		company:'McCann Prague'
	},
	{
		nume:'Matei Paspan',
		job:'Media Specialist',
		company:'V8 Interactive'
	},
	{
		nume:'Alex Dona',
		job:'Content Wizard',
		company:'Infant Media'
	},
	{
		nume:'Anda Bogdan',
		job:'Business Transformation Consultant',
		company:'Consultant Independent'
	},
	{
		nume:'Dan Vartopeanu',
		job:'Managing Partner',
		company:'Breeze Mobile Marketing'
	},
	{
		nume:'Cristiana Belodan',
		job:'Consultant Marketing & Comunicare',
		company:'Consultant Independent'
	},
	{
		nume:'Andrei Usuleanu',
		job:'Head of Sales',
		company:'Ringier'
	},
	{
		nume:'Raluca Mateiu',
		job:'CEO',
		company:'Internetcorp'
	},
	{
		nume:'Bianca Vlaston',
		job:'Director',
		company:'HTTPOOL'
	},
	{
		nume:'Andrei Bereanda',
		job:'Head of Digital Operations',
		company:'PROTV'
	},
	{
		nume:'Alin Alecu',
		job:'Managing Director',
		company:'ARBOmedia'
	},
	{
		nume:'Bogdan Slavescu',
		job:'Head of Biddable',
		company:'Groupm'
	},
	{
		nume:'Theodor Rusu',
		job:'Performance Specialist',
		company:'Groupm'
	},
	{
		nume:'Ioana Sigarteu',
		job:'Corporate Communication Manager',
		company:'Samsung'
	}
]

$(document).ready(function() {
	
	var video = document.getElementById('bgvideo');
	video.play();
	
	//scroll animations
	var controller = new ScrollMagic.Controller();

	var scene = new ScrollMagic.Scene({
			triggerElement: ".section2-trigger", duration: 0, offset: 0
		})
		.setTween(
			new TimelineMax()
			.fromTo(".section2", 0.5, {opacity: 0, y:'-100%'}, {opacity:1, y:'0%', ease: Power2.easeOut})
			.fromTo(".section2 h2", 0.25, {opacity: 0, x:'-100%'}, {opacity:1, x:'0%', ease: Power2.easeOut})
			.fromTo(".section2 .text", 0.25, {opacity: 0, x:'-100%'}, {opacity:1, x:'0%', ease: Power2.easeOut},'-=0.15')
			//.fromTo(".section2 .coffee", 0.5, {opacity: 0, x:'100%', rotation:360}, {opacity:1, x:'0%', rotation:0, ease: Power2.easeOut},'-=0.15')
		)
		.addTo(controller);
	
	var scene = new ScrollMagic.Scene({
			triggerElement: ".section2-trigger", duration: 1500, offset: 0
		})
		.setTween(
			new TimelineMax()
			//.fromTo(".section2 .coffee", 0.5, {opacity: 0, x:'100%', y:'0%', rotation:360}, {opacity:1, x:'0%', y:'0%', rotation:0, ease: Power2.easeOut},'-=0.15')
			.fromTo(".section2 .coffee", 0.5, {opacity: 1, y:'100%', rotation:0}, {opacity:1, y:'-100%', rotation:0, ease: Power2.easeOut},'-=0.15')
		)
		.addTo(controller);
	
	var scene = new ScrollMagic.Scene({
			triggerElement: ".section3-trigger", duration: 0, offset: 0
		})
		.setTween(
			new TimelineMax()
			.fromTo(".section3", 0.5, {opacity: 0, y:'-100%'}, {opacity:1, y:'0%', ease: Power2.easeOut})
			.fromTo(".section3 h2", 0.25, {opacity: 0, x:'-100%'}, {opacity:1, x:'0%', ease: Power2.easeOut})
			.fromTo(".section3 .text", 0.25, {opacity: 0, x:'-100%'}, {opacity:1, x:'0%', ease: Power2.easeOut},'-=0.15')
			.fromTo(".section3 .register-button", 0.5, {opacity: 0, x:'-500%'}, {opacity:1, x:'0%', ease: Back.easeOut})
		)
		.addTo(controller);
	
	var scene = new ScrollMagic.Scene({
			triggerElement: ".section4-trigger", duration: 0, offset: 0
		})
		.setTween(
			new TimelineMax()
			.fromTo(".section4 h2", 0.25, {opacity: 0, x:'-100%'}, {opacity:1, x:'0%', ease: Power2.easeOut})
			.fromTo(".section4 #jury", 0.5, {opacity: 0, y:'-10%'}, {opacity:1, y:'0%', ease: Power2.easeOut})
		)
		.addTo(controller);
	
	$('.register-button').on('click', function(event){
		event.preventDefault();
		new TimelineMax().fromTo(".section3 .register-button", 0.3, {x:'0%'}, {x:'500%', ease: Power2.easeOut, onComplete:function(){
			window.location.href = event.currentTarget.href;
		}});
	});
	
	$.each(juriu, function(index, value){
		$('#jury').append('<div class="col-xs-6 col-sm-4 col-md-3"><img src="img/jury/'+juriu[index].nume.replace(' ','-')+'.jpg" class="img-responsive"><p class="juror-name">'+juriu[index].nume+'</p><p class="juror-job"><strong>'+juriu[index].job+'</strong>, '+juriu[index].company+'</p></div>');
	});
});